import { getRenterProfileInfoForRenterProfilePage } from '@zg-rentals/clickstream';
import type { RenterInfoRenterProfileStandalonePageWebApiResponse } from '@zg-rentals/ts-renter-info-client';
import { trackRenterProfileEvent } from '../analytics';

type Profile = RenterInfoRenterProfileStandalonePageWebApiResponse;

export const emitRenterProfileSubmitEvent = (profile: Profile) =>
  trackRenterProfileEvent({
    envelope: {
      event_type_id: '2458',
      event_type_version_id: '2',
      event_template_id: '175',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'renter_profile',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'button_to_submit_renter_profile',
    },
    semantic: { semantic_event_nm: 'renter_profile_submit', topic_tag_txt: ['renter_profile'] },
    ...getRenterProfileInfoForRenterProfilePage(profile),
  });

export const emitRenterProfileClearEvent = (profile: Profile) =>
  trackRenterProfileEvent({
    envelope: {
      event_type_id: '3125',
      event_type_version_id: '2',
      event_template_id: '175',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'renter_profile',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'button_to_clear_renter_profile',
    },
    semantic: { semantic_event_nm: 'renter_profile_clear', topic_tag_txt: ['renter_profile'] },
    ...getRenterProfileInfoForRenterProfilePage(profile),
  });

export const emitRenterProfileNoCreditScoreEvent = (profile: Profile) =>
  trackRenterProfileEvent({
    envelope: {
      event_type_id: '7228',
      event_type_version_id: '2',
      event_template_id: '175',
      event_template_version_id: '1',
    },
    clickstream_trigger: {
      trigger_location_nm: 'renter_profile',
      trigger_type_nm: 'interaction',
      trigger_object_nm: 'no_trigger_object',
      trigger_source_nm: 'button_to_select_nocreditscore',
    },
    semantic: { semantic_event_nm: 'no_credit_score_selected', topic_tag_txt: ['renter_profile'] },
    ...getRenterProfileInfoForRenterProfilePage(profile),
  });
